import { Component, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { SweetAlertService } from 'src/app/services/sweet-alert.service';
import { UserService } from 'src/app/services/user.service';
import { NeoIntermediarioFinancieroService } from '../../Service/neoIntermediarioFinanciero.service';
declare var $: any;

@Component({
    selector: 'app-administrar-centrales-riesgo',
    templateUrl: './administrar-centrales-riesgo.component.html',
    styleUrls: ['./administrar-centrales-riesgo.component.scss'],
    standalone: false
})

export class AdministrarCentralesRiesgoComponent implements OnInit {

  // pagination
  totalPaginas: number = 1;
  paginaActual: number = 1;

  administrarCentralRiesgoForm: UntypedFormGroup;
  editarCentralRiesgoForm: UntypedFormGroup;
  isReportando: boolean = true;
  idCliente: any;
  aceptaSolicitudes: boolean = false
  validarEdicionCR: boolean = false;
  salvarParametros: boolean = true;
  isRegistroInvalido: boolean = false;
  // listas
  listaSectoresCR: any[] = [];
  listaParametrosCRCliente: any[] = [];
  constructor(private _formBuilder: UntypedFormBuilder,
    private _sweetAlert: SweetAlertService,
    private _user: UserService,
    private _intermediarioService: NeoIntermediarioFinancieroService
  ) {
  }

  ngOnInit(): void {
    this.idCliente = this._user.getUser().idCliente;
    this.obtenerSectoresCR();
    this.obtenerParametrosCRCliente();

    this.administrarCentralRiesgoForm = this._formBuilder.group({
      aceptaSolicitudes: new UntypedFormControl('', Validators.required),
      configuraciones: new UntypedFormArray([
      ])
    });

    this.editarCentralRiesgoForm = this._formBuilder.group({
      configuracionesEditar: new UntypedFormArray([
      ])
    });
  }

  // Listas
  obtenerSectoresCR() {
    this._intermediarioService.obtenerSectoresCR().subscribe((response: any) => {
      if (response.exitoso) {
        this.listaSectoresCR = response.sectores;
      } else {
        this._sweetAlert.errorModal("Error!", true, 'Error en el servicio');
      }
    }, (error: any) => {
      this._sweetAlert.errorModal("Error!", true, 'Error en el servicio');
    });
  }

  obtenerParametrosCRCliente() {
    this._intermediarioService.obtenerParametrosCRByCliente(this.idCliente).subscribe((response: any) => {
      if (response.exitoso) {
        this.listaParametrosCRCliente = response.configuraciones;
      } else {
        this._sweetAlert.errorModal("Error!", true, 'Error en el servicio');
      }
    }, (error: any) => {
      this._sweetAlert.errorModal("Error!", true, 'Error en el servicio');
    });
  }
  // fin listas

  // form array

  initGroupAdministrarCR(body: any): UntypedFormGroup {
    return this._formBuilder.group({
      idSectorCentralesRiesgo: new UntypedFormControl(body.idSectorCentralesRiesgo),
      nombreSector: new UntypedFormControl(body.nombre),
      aceptacionRiesgo: new UntypedFormControl(body.aceptacionRiesgo),
      maximoDias: new UntypedFormControl(body.maximoDias),
      idCliente: new UntypedFormControl(this.idCliente)
    });
  }

  get configuraciones(): UntypedFormArray {
    return this.administrarCentralRiesgoForm.get('configuraciones') as UntypedFormArray;
  }

  initGroupEditarCR(body: any): UntypedFormGroup {
    return this._formBuilder.group({
      idSectorCentralesRiesgo: new UntypedFormControl(body.idSectorCentralesRiesgo),
      idConfCentralesRiesgoIntermediario: new UntypedFormControl(body.idConfCentralesRiesgoIntermediario),
      nombreSector: new UntypedFormControl(body.nombre),
      aceptacionRiesgo: new UntypedFormControl(body.aceptacionRiesgo),
      maximoDias: new UntypedFormControl(body.maximoDias),
      idCliente: new UntypedFormControl(this.idCliente)
    });
  }

  get configuracionesEditar(): UntypedFormArray {
    return this.editarCentralRiesgoForm.get('configuracionesEditar') as UntypedFormArray;
  }

  // CRUD PARAMETRIZAR CENTRAL RIESGO

  aceptaSolicitudesReportadas(valor: boolean) {
    let json = {
      idSectorCentralesRiesgo: 1,
      aceptacionRiesgo: '',
      nombre: '',
      maximoDias: ''
    }
    if (valor == true) {
      this.configuraciones.clear();
      this.aceptaSolicitudes = false
      for (let i = 0; i < this.listaSectoresCR.length; i++) {
        json.idSectorCentralesRiesgo = this.listaSectoresCR[i]?.idSectorCentralesRiesgo
        json.nombre = this.listaSectoresCR[i]?.nombre
        this.configuraciones.push(this.initGroupAdministrarCR(json));
      }
    } else {
      this.configuraciones.clear();
      setTimeout(() => {
        $('.selectpicker').selectpicker('refresh');
      }, 100);
      this.aceptaSolicitudes = true
      for (let i = 0; i < this.listaSectoresCR.length; i++) {
        json.idSectorCentralesRiesgo = this.listaSectoresCR[i]?.idSectorCentralesRiesgo
        json.nombre = this.listaSectoresCR[i]?.nombre
        this.configuraciones.push(this.initGroupAdministrarCR(json));
      }
    }
  }

  guardarParametrizacionCR() {
    let parametrosCR: any[] = [];
    let json: { idCliente: number, idSectorCentralesRiesgo: number, aceptacionRiesgo: boolean, maximoDias: number };
    let auxAceptaSolicitudes = String(this.administrarCentralRiesgoForm.get('aceptaSolicitudes').value);
    if (auxAceptaSolicitudes == '1') {
      for (let elemento of this.configuraciones.controls) {
        json = {
          idCliente: +this.idCliente,
          idSectorCentralesRiesgo: elemento.get('idSectorCentralesRiesgo').value,
          aceptacionRiesgo: true,
          maximoDias: elemento.get('maximoDias').value
        }
        parametrosCR.push(json);
      }
      this.salvarParametros = true;
      this.isRegistroInvalido = false;
      this.configuraciones.clear();
      this.callServiceSaveCR(parametrosCR);
      this.administrarCentralRiesgoForm.reset();
    } if (auxAceptaSolicitudes == '0') {
      this.salvarParametros = false;
      for (let elemento of this.configuraciones.controls) {
        json = {
          idCliente: +this.idCliente,
          idSectorCentralesRiesgo: elemento.get('idSectorCentralesRiesgo').value,
          aceptacionRiesgo: true,
          maximoDias: elemento.get('maximoDias').value
        }
        if (elemento.get('aceptacionRiesgo').value == 'true' || elemento.get('aceptacionRiesgo').value) {
          json.aceptacionRiesgo = true;
          parametrosCR.push(json);
          this.salvarParametros = true;
          this.isRegistroInvalido = false;
        } if (elemento.get('aceptacionRiesgo').value == 'false' || !elemento.get('aceptacionRiesgo').value) {
          json.aceptacionRiesgo = false
          if (elemento.get('maximoDias').value != '') {
            parametrosCR.push(json);
            this.salvarParametros = true;
          } else {
            this.salvarParametros = false;
            break;
          }
        } else if (elemento.get('aceptacionRiesgo').value == '') {
          this.isRegistroInvalido = true;
        }
      }
      if (parametrosCR.length == this.configuraciones.length) {
        this.configuraciones.clear();
        this.callServiceSaveCR(parametrosCR);
        this.administrarCentralRiesgoForm.reset();
      } else {
        if (this.salvarParametros == false) {
          this._sweetAlert.infoModal('Registre los días de mora máximos tolerables', false, 'De acuerdo a si no acepta las moras en cada sector')
        }
        if (this.isRegistroInvalido) {
          this._sweetAlert.infoModal('Registro invalido', false)
        }
      }
    }
  }


  callServiceSaveCR(body: any) {
    if (this.listaParametrosCRCliente.length == 0) {
      this._intermediarioService.saveCentralesRiesgo(body)
        .subscribe((response: any) => {
          if (response.exitoso) {
            this._sweetAlert.successModal("Cambios guardados");
            this.aceptaSolicitudes = false;
            this.obtenerParametrosCRCliente();
          } else {
            this._sweetAlert.errorModal("Error en el servicio", true);
          }
        }, (error) => {
          this._sweetAlert.errorModal("Error en el servicio", true);
        });
      setTimeout(() => {
        $('.selectpicker').selectpicker('refresh');
      }, 100);
    } else {
      this.aceptaSolicitudes = false;
      this._sweetAlert.infoModal("Atención", false, 'Usted ya tiene parametrización de reportes negativos en centrales de riesgo');
    }


  }

  // limpiar form administrar CR
  limpiar() {
    this.administrarCentralRiesgoForm.reset();
    this.aceptaSolicitudes = false;
    this.configuraciones.clear();
  }
  // fin 

  // Editar CR
  editarFila() {
    this.configuracionesEditar.clear()
    setTimeout(() => {
      $('.selectpicker').selectpicker('refresh');
    }, 100);
    this.listaParametrosCRCliente.forEach((elemento) => {
      this.configuracionesEditar.push(this.initGroupEditarCR(elemento));
    })
    $('#modal-editar').modal('show');
  }

  confirmarEditarCR() {
    for (let elemento of this.configuracionesEditar.controls) {
      if (elemento.get('aceptacionRiesgo').value =='false' || !elemento.get('aceptacionRiesgo').value) {
        elemento.get('aceptacionRiesgo').setValue(false);
        if (elemento.get('maximoDias').value != null) {
          this.validarEdicionCR = true;
        } else {
          elemento.get('maximoDias').setValue(0);
          // this.validarEdicionCR = false;
          // this._sweetAlert.infoModal('Registre los días de mora mínimos tolerables', false, 'De acuerdo a si no acepta las moras en cada sector')
          // break;
        }
      } if (elemento.get('aceptacionRiesgo').value == 'true' || elemento.get('aceptacionRiesgo').value) {
        elemento.get('aceptacionRiesgo').setValue(true);
        this.validarEdicionCR = true;
      } else {
        this.validarEdicionCR = true;
      }
    }

    if (this.validarEdicionCR) {
      this.callServiceUpdateCR(this.configuracionesEditar.value);
    }
  }

  callServiceUpdateCR(body: any) {
    if (body.length) {
      this._intermediarioService.updateCentralesRiesgo(body)
        .subscribe((response: any) => {
          if (response.exitoso) {
            this._sweetAlert.successModal("Cambios guardados");
            this.obtenerParametrosCRCliente();
          } else {
            this._sweetAlert.errorModal("Error", true, 'No se registraron cambios');
          }
        }, (error) => {
          this._sweetAlert.errorModal("Error en el servicio", true);
        });
      $('#modal-editar').modal('hide');
    }
  }

  isValidForm(field: string) {
    return (
      (this.administrarCentralRiesgoForm.get(field).dirty ||
        this.administrarCentralRiesgoForm.get(field)?.touched) &&
      this.administrarCentralRiesgoForm.get(field)?.invalid
    );
  }
}